import {
    GALLERY_COLUMN_WIDTH_MOBILE,
    GALLERY_COLUMN_WIDTH,
} from '@modules/page-builder/config/column-constants';
import type { ImageProps } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import type { ImageColumnProps } from '@modules/page-builder/types';
import DetailSingleImageShell from '../detail-single-image-shell/DetailSingleImageShell';
import * as S from './GalleryModule.style';
import React from 'react';
import PreviewImage from '@modules/page-builder/component/edit/page-builder-image/PreviewImage';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '@modules/page-builder/component/common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail-mobile/detail-modules/DetailModules.style';
import ProductInfo from '@modules/page-builder/component/common/product-info/ProductInfo';

interface GalleryModuleProps {
    columns: ImageColumnProps[];
}

const GalleryModule = ({ columns }: GalleryModuleProps) => {
    const { css } = useStyles();

    return (
        <div className={css(S.GalleryModuleContainer, ImageModuleExtraSpacing)}>
            {columns.map((column) => {
                const imageProps: Omit<ImageProps, 'src'> = {
                    layout: 'fill',
                    width: column.dimension.width,
                    height: column.dimension.height,
                    objectFit: 'cover',
                    fadeIn: false,
                    alt: '',
                };

                const imageShell = column.imageUrl ? (
                    <DetailSingleImageShell
                        key={column.id}
                        dimension={column.dimension}
                        className={css(S.ImageContainer)}
                        libraryImage={column.libraryImage}
                        taggingEnabled={false}
                        displayReseneTool={false}
                        imageURL={column.imageUrl}
                        isProduct={!!column.productId}
                    >
                        <ImageWithPaintPicker
                            src={column.imageUrl}
                            width={column.dimension.width}
                            height={column.dimension.height}
                            layout={'fill'}
                            objectFit={'cover'}
                            sizes={getImagesSizes({
                                desktop: GALLERY_COLUMN_WIDTH,
                                mobile: GALLERY_COLUMN_WIDTH_MOBILE,
                            })}
                            alt={
                                column.caption ||
                                column?.libraryImage?.Title ||
                                ''
                            }
                            variables={{
                                mixBlendMode: column.productId
                                    ? 'multiply'
                                    : 'normal',
                            }}
                        />
                    </DetailSingleImageShell>
                ) : (
                    <div className={css(S.ImageContainer)} key={column.id}>
                        <PreviewImage
                            show={true}
                            imageUrl={column.imageOptimistic}
                            imageProps={imageProps}
                        />
                    </div>
                );

                return column.productId ? (
                    <ProductInfo
                        productId={column.productId}
                        variant={'01'}
                        image={imageShell}
                        clickable={true}
                        dimension={column.dimension}
                    />
                ) : (
                    imageShell
                );
            })}
        </div>
    );
};

export default GalleryModule;
